import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import battle1 from "../../assets/images/Battles/battle1.png";
import battle2 from "../../assets/images/Battles/battle2.png";
import {ReactComponent as Swords} from "../../assets/icons/swords.svg";
import { useNavigate } from "react-router-dom";
import { routes } from "../../routes";
import FlippingCoin from "./FlippingCoin";
import FlipCountDown from "./countDown/FlipCountDown";
import SpinBackground from "../../assets/images/spinBackground.png";

// Must match the CSS spin-heads / spin-tails animation duration
const COIN_SPIN_DURATION_MS = 2000;

const CoinFlip = ({ player1, player2, battle_id, setBattle, flipWinner }) => {
  const isDarkMode = useSelector((state) => state.theme.darkMode);
  const user = useSelector((state) => state.auth.user);
  const navigate = useNavigate();
  const [coinClass, setCoinClass] = useState(null);
  const [showCountdown, setShowCountdown] = useState(true);
  const [isWaitingForWinner, setIsWaitingForWinner] = useState(false);

  // ✅ NEW: amounts are hidden until the coin finishes spinning
  const [showAmounts, setShowAmounts] = useState(false);

  // Helper function to safely format amount
  const formatAmount = (amount) => {
    const numAmount = parseFloat(amount || 0);
    return numAmount.toFixed(2);
  };

  const handleCountdownComplete = () => {
    setShowCountdown(false);
    setIsWaitingForWinner(true);
  };

  const getAllPlayerIds = (player) => {
    const ids = new Set();
    if (player?.user_id) ids.add(Number(player.user_id));
    if (player?.user?.id) ids.add(Number(player.user.id));
    if (player?.id) ids.add(Number(player.id));
    if (player?.userdetails?.id) ids.add(Number(player.userdetails?.id));
    return ids;
  };

  const isWinnerPlayer = (player, winnerId) => {
    if (!player || !winnerId) return false;
    const playerIds = getAllPlayerIds(player);
    return playerIds.has(Number(winnerId));
  };

  const determineCoinClass = (winnerId) => {
    if (!winnerId) return null;

    if (isWinnerPlayer(player1, winnerId)) {
      return "heads";
    } else if (isWinnerPlayer(player2, winnerId)) {
      return "tails";
    } else {
      console.warn("⚠️ Winner ID doesn't match any player!", {
        winnerId,
        player1Ids: [...getAllPlayerIds(player1)],
        player2Ids: [...getAllPlayerIds(player2)],
      });
      return null;
    }
  };

  // ✅ When coinClass is set, start a timer to reveal amounts after the spin
  useEffect(() => {
    if (!coinClass) return;

    setShowAmounts(false); // reset in case of re-mount
    const timer = setTimeout(() => {
      setShowAmounts(true);
    }, COIN_SPIN_DURATION_MS + 5000); // slight buffer after animation ends

    return () => clearTimeout(timer);
  }, [coinClass]);

  // Check if winner is already available when component mounts
  useEffect(() => {
    if (flipWinner && !coinClass) {
      const result = determineCoinClass(flipWinner);
      if (result) {
        setCoinClass(result);
      }
    }
  }, [flipWinner, player1, player2]);

  // Watch for flipWinner after countdown completes
  useEffect(() => {
    if (isWaitingForWinner && flipWinner) {
      const result = determineCoinClass(flipWinner);
      if (result) {
        setCoinClass(result);
      }
      setIsWaitingForWinner(false);
    }
  }, [flipWinner, isWaitingForWinner, player1, player2]);

  return (
    <div
     style={{
                  backgroundImage: `url(${SpinBackground})`,
                  backgroundSize:"cover"

        }}
      className={isDarkMode ? "end-battle-detail-dark" : "end-battle-detail"}
    >
      <h1 style={{ color: "#FFCB21" }}>It's a tie!</h1>

      <div className="mt-4 battle-end-icons">
        <div className="battle-end-icons-details">
          <img
            src={
              player1?.user?.userdetails?.avatar
                ? `${player1?.user?.userdetails?.avatar}`
                : player1?.userdetails?.avatar
                  ? `${player1?.userdetails?.avatar}`
                  : battle1
            }
            alt="Player 1"
          />
          {/* ✅ Show placeholder until the coin animation finishes */}
          <span
            style={{
              color: showAmounts
                ? parseFloat(player1?.total_amount || 0) > 0
                  ? "#06B6C7"
                  : "#FF6F67"
                : "#888888",
            }}
          >
            {showAmounts && `$${formatAmount(player1?.total_amount)}`}
          </span>
          <span>
  {player1?.user?.userdetails?.username ||
    player1?.userdetails?.userdetails?.username ||
    player1?.user?.username ||
    player1?.username ||
    "Player 1"}
</span>
        </div>

        <Swords
              className="sword-icon-color"
            style={{ width: "40px", height: "40px" }}
            />

        <div className="battle-end-icons-details">
          <img
            src={
              player2?.user?.userdetails?.avatar
                ? `${player2?.user?.userdetails?.avatar}`
                : player2?.userdetails?.avatar
                  ? `${player2?.userdetails?.avatar}`
                  : battle2
            }
            alt="Player 2"
          />
          {/* ✅ Show placeholder until the coin animation finishes */}
          <span
            style={{
              color: showAmounts
                ? parseFloat(player2?.total_amount || 0) > 0
                  ? "#06B6C7"
                  : "#FF6F67"
                : "#888888",
            }}
          >
            {showAmounts && `$${formatAmount(player2?.total_amount)}`}
          </span>
<span>
  {player2?.user?.userdetails?.username ||
    player2?.userdetails?.userdetails?.username ||
    player2?.user?.username ||
    player2?.username ||
    "Player 2"}
</span>        </div>
      </div>

      <div className="mt-3 FlippinRev">
        {showCountdown ? (
          <FlipCountDown onComplete={handleCountdownComplete} height={""} />
        ) : coinClass ? (
          <FlippingCoin
            battle1={
              player1?.user?.userdetails?.avatar
                ? `${player1?.user?.userdetails?.avatar}`
                : player1?.userdetails?.avatar
                  ? `${player1?.userdetails?.avatar}`
                  : battle1
            }
            battle2={
              player2?.user?.userdetails?.avatar
                ? `${player2?.user?.userdetails?.avatar}`
                : player2?.userdetails?.avatar
                  ? `${player2?.userdetails?.avatar}`
                  : battle2
            }
            result={coinClass}
          />
        ) : (
          <div className="flip-loading">
            <p style={{ color: "#FFCB21" }}>Determining winner...</p>
          </div>
        )}
      </div>

      <div className="endBattleBtns mt-5">
        <button
          className="filled-medium-deep-yellow-btn-dark "
          onClick={() => navigate(routes.BATTLES)}
        >
          <span>Back to Battles</span>
        </button>
      </div>
    </div>
  );
};

export default CoinFlip;